import React, { useEffect, useState } from "react";
import Circlebtn from "../components/Circlebtn";
import DotMenu from "../components/DotMenu";
import GroupFileCard from "../components/GroupFileCard";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import { BarChartIcon, CheckCircleIcon, CrossIcon, PlusIcon, ScheduleCalendarIcon, TrashIcon, UserSettingsIcon, VideoIcon } from "../assets/icons/Icons";
import MainModal from "../components/MainModal";
import UploadFileModal, { UploadFileModalStep2, UploadFileModalStep3 } from "../components/UploadFileModal";
import { CardSkeletonLoader } from "../components/CardSkeletonLoader";

const options = [
  { label: "Select many groups", icon: CheckCircleIcon },
  { label: "Manage access", icon: UserSettingsIcon },
];

const Files = () => {
  const [selected, setSelected] = useState<string>("");
  const [checked, setChecked] = useState<boolean>(false);
  const [showUploadNF, setShowUploadNF] = useState<boolean>(false);
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [showChooseG, setShowChooseG] = useState<boolean>(false);
  const redirect = useRedirect();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);
  useEffect(() => {
    if (selected === options[0].label) {
      setChecked(true);
    }
  }, [selected]);
  return (
    <>
      <div className="flex items-center justify-between">
        <h1 className="text-[#0F0C18] text-[28px] font-medium leading-9 tracking-tight">Content Group</h1>
        <div className="flex items-center gap-2">
          <Circlebtn onClick={() => setShowUploadNF(true)} icon={<PlusIcon />} className="w-8 h-8 bg-white" />
          <DotMenu setSelected={(option) => setSelected(option)} options={options} type="circle" />
        </div>
      </div>
      <p className="text-[#9392A2] mt-4 text-xs font-medium tracking-tight">Statistics</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">726</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Overall files</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">6</h1>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Overall groups</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <div className="flex items-start justify-between">
            <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">234</h1>
            <VideoIcon width={16} height={16} stroke="#0F0C18" />
          </div>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Video content files</p>
        </div>
        <div className="w-[282px] h-[92px] bg-white p-4 rounded-xl">
          <div className="flex items-start justify-between">
            <h1 className="text-[#0F0C18] text-[28px] font-medium tracking-tight mb-1">492</h1>
            <BarChartIcon width={16} height={16} stroke="#0F0C18" />
          </div>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">Voice content files</p>
        </div>
      </div>
      <p className="text-[#9392A2] mt-10 mb-3 text-xs font-medium tracking-tight">6 file groups</p>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
            [...Array(6)].map((_, index) => <CardSkeletonLoader key={index} />) :
            [...Array(6)].map((_, index) => <GroupFileCard check={checked} key={index} />)
        }
      </div>
      {
        selected === options[0].label &&
        <div className="flex items-end justify-between gap-3 bg-white rounded-full w-[240px] py-2 px-8 shadow-xl fixed left-[55%] transform -translate-x-1/2 bottom-8 z-50">
          <div onClick={() => {
            setSelected("");
            setChecked(false);
          }} className="flex flex-col items-center justify-center cursor-pointer">
            <CrossIcon />
            <p className="text-[#0F0C18] text-[10px] font-medium tracking-tight">Cancel</p>
          </div>
          <div className="flex flex-col items-center justify-center cursor-pointer">
            <TrashIcon />
            <p className="text-[#9392A2] text-[10px] font-medium tracking-tight">Delete</p>
          </div>
          <div onClick={() => redirect(pathnames.schedulePublish)} className="flex flex-col items-center justify-center cursor-pointer">
            <ScheduleCalendarIcon />
            <p className="text-[#9392A2] text-[10px] font-medium tracking-tight">Schedule</p>
          </div>
        </div>
      }
      {
        showUploadNF &&
        <MainModal
          subLabel="Step 1 of 3"
          setShowModal={setShowUploadNF}
        >
          <UploadFileModal showNext={() => {
            setShowUploadNF(false)
            setShowPreview(true)
          }} />
        </MainModal>
      }
      {
        showPreview &&
        <MainModal
          subLabel="Step 2 of 3"
          setShowModal={setShowPreview}
        >
          <UploadFileModalStep2 showNext={() => {
            setShowPreview(false)
            setShowChooseG(true)
          }} />
        </MainModal>
      }
      {
        showChooseG &&
        <MainModal
          subLabel="Step 3 of 3"
          setShowModal={setShowChooseG}
        >
          <UploadFileModalStep3 showPrev={() => {
            setShowChooseG(false)
            setShowPreview(true)
          }} />
        </MainModal>
      }
    </>
  );
};

export default Files;